import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/services/http/http.service';
import { URLParamsService } from '@shared/services/url-params.service';
import { OfferViewModel } from '../models/offer.model';
import { RestaurantTypes } from '../enums/restaurant-type';
import { OfferDto } from '../models/OfferDto.model';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class OffersService {
    static readonly url = 'Offer/';

    constructor(private httpService: HttpService) { }

    saveOffer(dto: OfferDto): Observable<any> {
        const url = `${OffersService.url}SaveOffer`;
        const data = new FormData();
        data.append('File', dto.File);
        data.append('restaurantType', String(dto.RestaurantType));
        return this.httpService.PostRequestFormData<any, FormData>(url, data);
    }
    getOffers(restaurantType: RestaurantTypes): Observable<OfferViewModel[]> {
        const url = URLParamsService.buildUrl(`${OffersService.url}GetOffers`,
            {
                'restaurantType': restaurantType
            });
        return this.httpService.GetRequest<OfferViewModel[]>(url);
    }

    DeleteOffer(id: number): Observable<any> {
        const url = URLParamsService.buildUrl(`${OffersService.url}DeleteOffer/${id}`, null);
        return this.httpService.DeleteRequest(url, null);
    }

}
